import { Component, View, ViewModel } from "binder";
import  { PictureCaptureView } from "./pictureCapture-view"

export class PictureCaptureViewModel extends Component{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.showFront = false;
        
    }
    GetDefaultView(): View <ViewModel> {
        return new PictureCaptureView();
    }
    public getTypeId(): string {
        return "VM-CDA10ECD-44F0-401F-83DE-9696E04AEE4C"
    }

    public set image(v: string) { this._image = v; } public get image(): string { return this._image;} private _image: string;
    public set showFront(v: boolean) { this._showFront = v; } public get showFront(): boolean { return this._showFront;} private _showFront: boolean;
    
}
